import { Col, Input, Label } from "reactstrap";
import { Indeterminate, IndeterminateCheckbox } from "../../../../Constant";
import { H6 } from "../../../../AbstractElements";

export const Indeterminates = () => {
  return (
    <Col xl="12" sm="6">
      <div className="card-wrapper border rounded-3 checkbox-checked">
        <H6 className="sub-title">{Indeterminate}</H6>
        <div className="form-check">
          <Input id="flexCheckIndeterminate" type="checkbox" />
          <Label htmlFor="flexCheckIndeterminate" check>
            {IndeterminateCheckbox}
          </Label>
        </div>
      </div>
    </Col>
  );
};
